module.exports = __webpack_public_path__ + "img/current.webp";